// extracted by mini-css-extract-plugin
module.exports = {"container":"gavin_container__2pSPV","uploadZone":"gavin_uploadZone__eVIDl","form":"gavin_form__2wg_I","fileList":"gavin_fileList__2cCG0","buttons":"gavin_buttons__2B-qA"};